import { cn } from "@/lib/utils/cn";
import { Popover as BasePopover } from "@base-ui/react/popover";
import * as React from "react";

const PopoverRoot = ({ ...props }: React.ComponentProps<typeof BasePopover.Root>) => {
  return <BasePopover.Root {...props} />;
};

const PopoverTrigger = ({ ...props }: React.ComponentProps<typeof BasePopover.Trigger>) => {
  return <BasePopover.Trigger data-slot="popover-trigger" {...props} />;
};

type PopoverContentProps =
  & React.ComponentProps<typeof BasePopover.Popup>
  & Pick<
    React.ComponentProps<typeof BasePopover.Positioner>,
    "side" | "align" | "sideOffset" | "alignOffset" | "anchor"
  >;

const PopoverContent = ({
  align = "center",
  side = "bottom",
  sideOffset = 4,
  alignOffset,
  anchor,
  className,
  ...props
}: PopoverContentProps) => {
  return (
    <BasePopover.Portal>
      <BasePopover.Positioner
        className="z-50"
        side={side}
        align={align}
        sideOffset={sideOffset}
        {...(alignOffset !== undefined && { alignOffset })}
        {...(anchor !== undefined && { anchor })}
      >
        <BasePopover.Popup
          data-slot="popover-content"
          className={cn(
            "w-72 origin-[var(--transform-origin)] rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden transition-[transform,scale,opacity] data-[ending-style]:scale-95 data-[ending-style]:opacity-0 data-[starting-style]:scale-95 data-[starting-style]:opacity-0",
            className,
          )}
          {...props}
        />
      </BasePopover.Positioner>
    </BasePopover.Portal>
  );
};

const PopoverClose = ({ ...props }: React.ComponentProps<typeof BasePopover.Close>) => {
  return <BasePopover.Close data-slot="popover-close" {...props} />;
};

export const Popover = Object.assign(PopoverRoot, {
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Close: PopoverClose,
});
